import {
  convertUnifiedDateStringToDateObject,
  getAge,
  getSpecificDateStringInUnifiedFormat
} from 'Utils/date/dateUtils';
import CONFIG from 'Config/settings';
import { exists } from 'Utils/localization/i18next';
import { generalRegex } from 'Utils/validation/regex/generalRegex';
import validationMessage from '../validationMessage/validationMessage';
import {
  getFieldKeyByLabel,
  resolveFieldPolicyRegExps
} from '../validationRules/validationRules';

const UNIFIED_DATE_VALIDITY_REGEXP = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;

const EDVE_DATE_FORMATS = {
  'date.dd_mm_yyyy_dashed': 'DD-MM-YYYY',
  'date.dd_mm_yyyy_dotted': 'DD.MM.YYYY',
  'date.yyyy_mm_dd_dashed': 'YYYY-MM-DD',
  'date.yyyy_mm_dd_dotted': 'YYYY.MM.DD'
};

const birthDate = (
  value = '',
  label,
  {
    minAge = Number.MIN_SAFE_INTEGER,
    maxAge = Number.MAX_SAFE_INTEGER,
    format = 'DD-MM-YYYY',
    message
  }
) => {
  if (!value.length) {
    return undefined;
  }
  const fieldKey = getFieldKeyByLabel(label);
  const resolvedPolicy = resolveFieldPolicyRegExps(
    fieldKey,
    CONFIG.COUNTRY.toUpperCase()
  );
  const constraints = resolvedPolicy?.constraints;
  const dateFormat =
    EDVE_DATE_FORMATS[(constraints?.displayFormatId)] ?? format;
  const minimumAge = constraints?.minAge ?? minAge;
  const maximumAge = constraints?.maxAge ?? maxAge;
  const birthDateRegExp = generalRegex.dateFormat?.[dateFormat];

  if (!birthDateRegExp || !birthDateRegExp.test(value)) {
    return validationMessage('birthDateFormat', label, message, {
      format: dateFormat
    });
  }

  const formattedDateStr = getSpecificDateStringInUnifiedFormat(
    value,
    dateFormat
  );
  if (!UNIFIED_DATE_VALIDITY_REGEXP.test(formattedDateStr)) {
    return validationMessage(
      exists('forms.validation.birthDateInvalid')
        ? 'birthDateInvalid'
        : 'invalid',
      label,
      message,
      {
        format: dateFormat
      }
    );
  }

  const birthDateObj = convertUnifiedDateStringToDateObject(formattedDateStr);
  const age = getAge(birthDateObj);

  if (age < minimumAge || age > maximumAge) {
    const minStr = minimumAge !== Number.MIN_SAFE_INTEGER ? minimumAge : '';
    const maxStr = maximumAge !== Number.MAX_SAFE_INTEGER ? maximumAge : '';
    const delimiterStr = minStr !== '' && maxStr !== '' ? '-' : '';
    const range = `${minStr}${delimiterStr}${maxStr}`;
    return validationMessage('birthDateAge', label, message, { range });
  }
  return undefined;
};

export { birthDate };
